module.exports = __webpack_public_path__ + "img/1-unsplash.5c9310cb.jpg";